import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '@/auth/hanko';

// "/" never renders — it only decides where to send the visitor. Mirrors the portal-first
// flow from BILLING_PLAN.md §4/D4: an authenticated chef lands on the instance list, everyone
// else on login.
export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const authed = await isAuthenticated();
    throw redirect({ to: authed ? '/instances' : '/login' });
  },
});
